// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1KN6j","rightAdornment":"Header_rightAdornment__3V7BO"};